export default __webpack_public_path__ + "static/media/headerImg3.0a0c0f9d.webp";